import { t } from 'i18next';
import { useVersionCheck } from '../../hooks/useVersionCheck';

export function VersionUpdateBanner() {
    const { needsUpdate, reloadApp } = useVersionCheck();

    if (!needsUpdate) {
        return null;
    }

    return (
        <div className="version-update-banner">
            <div className="version-update-content">
                <i className="bi bi-arrow-clockwise"></i>
                <span>{t("A new version is available. Please reload the page to get the latest updates.")}</span>
                <button onClick={reloadApp} className="btn btn-sm btn-light">
                    {t("Reload")}
                </button>
            </div>
        </div>
    );
}
